export default __webpack_public_path__ + "static/top_baloon-37d189a6dad4bb063940fce48540868f.png";